// extracted by mini-css-extract-plugin
export default {"content":"TQ-z","lookName":"UQ-z","shopTheLookContainer":"VQ-z","productContainer":"WQ-z","imageContainer":"XQ-z","mainImage":"YQ-z"};